import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "children", "placement", "trigger", "content", "delay", "popperConfig"];
import React from 'react';
import PropTypes from 'prop-types';
import Tooltip, { TooltipPlacementType } from './Tooltip';
import OverlayTrigger, { triggerType } from '../overlay/OverlayTrigger';
var SimpleTooltip = function SimpleTooltip(props) {
  var id = props.id,
    children = props.children,
    placement = props.placement,
    trigger = props.trigger,
    content = props.content,
    delay = props.delay,
    popperConfig = props.popperConfig,
    remainingProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: placement,
    trigger: trigger,
    overlay: /*#__PURE__*/React.createElement(Tooltip, remainingProps, content),
    delay: delay,
    popperConfig: popperConfig
  }, children);
};
SimpleTooltip.defaultProps = {
  placement: Tooltip.AUTO
};
SimpleTooltip.propTypes = {
  placement: TooltipPlacementType,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  trigger: triggerType,
  targetRef: PropTypes.func,
  popperConfig: PropTypes.object,
  delay: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    show: PropTypes.number,
    hide: PropTypes.number
  })]),
  children: PropTypes.node.isRequired
};
export default SimpleTooltip;